import ServiceFeature from '@scentregroup/shared/components/service-feature'
import { PromotionPositionContext } from '@scentregroup/shared/context'
import React, { Fragment } from 'react'
import { CentreTradingHours } from '../../../../../src/shared/helpers/parse-opening-hours/types'
import { SGPageTemplateWithAdZones } from '@scentregroup/shared/types/page-templates'
import { Centre } from '../../../lib/get-centre-by-slug'
import { ContentDetail } from '../../../lib/get-content-detail'
import { Template } from '@scentregroup/shared/components/page-templates/template'

interface IServiceContentDetailProps {
  centre: Centre
  content: ContentDetail['service']
  template: SGPageTemplateWithAdZones
  centreTradingHours: CentreTradingHours
}

export const ServiceContentDetail = ({
  centre,
  content: service,
  template,
  centreTradingHours,
}: IServiceContentDetailProps): JSX.Element => (
  <Fragment>
    <PromotionPositionContext.Provider
      value={service?.analyticsMetadata?.correlationId ?? undefined}
    >
      <ServiceFeature
        centred
        position="left"
        title={service.title}
        body={service.bodyCopy}
        centre={centre}
        centreTradingHours={centreTradingHours}
        analyticsMetadata={service.analyticsMetadata}
      />
      <Template template={template} />
    </PromotionPositionContext.Provider>
  </Fragment>
)
